import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatMenuModule} from '@angular/material/menu';
import { Router, RouterModule } from '@angular/router';
import { NotificationService } from '../../core/service/notification.service';
import { AuthService } from '../../core/service/auth-service';
@Component({
  selector: 'app-left-nav',
  imports: [CommonModule, MatMenuModule, RouterModule],
  templateUrl: './left-nav.component.html',
  styleUrl: './left-nav.component.css'
})
export class LeftNavComponent implements OnInit {
  userInfo:any;
  userType: string = '';
  
  constructor(private router: Router, 
    private toastr: NotificationService,
    private authService: AuthService){}

  ngOnInit(): void {
     const data = localStorage.getItem('UserDetails');
    if (data) {
      this.userInfo = JSON.parse(data);
      this.userType = this.userInfo?.userType || '';
    }
  }

  isNRI(): boolean {
    return this.userType === 'NRI';
  }

  isAdmin(): boolean {
    return this.userType === 'admin';
  }

  isServiceProvider(): boolean {
    return this.userType === 'Service Provider';
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']); 
  }
}
